import * as React from 'react';

import ActionButton from 'components/action-button';
import { useLoyaltyPoints } from 'hooks/loyalty/use-loyalty-points';
import { t } from 'state/intl/translations';
import { LoyaltyUser } from 'state/loyalty/hooks/types';
import { routes } from 'utils/routing';

import {
  AvailableBalance,
  AvailablePoints,
  Divider,
  ExpirationDateTime,
  ExpirationMessage,
  NormalText,
  PointsExpirationContainer,
  PointsExpirationContent,
  PointsExpirationHeader,
  PurchaseMessage,
  StyledLoyaltyPointsIcon,
  StyledRewardsLogo,
} from './points-expiration.styled';

export const PointsExpirationCard: React.FC<React.PropsWithChildren<{
  loyaltyUser: LoyaltyUser;
}>> = ({ loyaltyUser }) => {
  const {
    userHasExpiringPoints,
    pointsExpirationDate,
    currentPoints,
    pointsToExpire,
    isNewPointsModel,
  } = useLoyaltyPoints(loyaltyUser);

  const pointsAndCrowns = (points: number) => (
    <>
      <StyledLoyaltyPointsIcon />
      <AvailablePoints>{points}</AvailablePoints>
    </>
  );

  const expirationMessage = isNewPointsModel ? t('crownsWillExpireOn') : t('yourPointsWillExpire');

  return (
    <PointsExpirationContainer testID="points-expiration-card">
      <PointsExpirationHeader>
        <StyledRewardsLogo />
        <AvailableBalance>
          <NormalText>{t('youHave')}</NormalText>
          {pointsAndCrowns(currentPoints)}
          <NormalText>{t('available').toLocaleLowerCase()}</NormalText>
        </AvailableBalance>
      </PointsExpirationHeader>
      <Divider />
      <PointsExpirationContent>
        <ExpirationMessage>
          {userHasExpiringPoints && isNewPointsModel && pointsAndCrowns(pointsToExpire)}
          <NormalText>{expirationMessage}</NormalText>
        </ExpirationMessage>
        <ExpirationDateTime testID="expiration-datetime">
          {pointsExpirationDate.formatted}
        </ExpirationDateTime>
        {!userHasExpiringPoints && <PurchaseMessage>{t('maintainYourPoints')}</PurchaseMessage>}
        <ActionButton fullWidth to={routes.menu}>
          {t('orderNow')}
        </ActionButton>
      </PointsExpirationContent>
    </PointsExpirationContainer>
  );
};
